import { idFacility, idsFacilities } from '@ve/pages/serp/components/filters/facilitiesFilter/common';

export default function getPropertyFacilities(
    idsTypes: number[] = [],
    idsAttributes: number[] = [],
): idsFacilities[] {
    const result: idsFacilities[] = [];

    if (!idsAttributes.includes(250)) result.push(idFacility.lonelyMan);
    if (idsAttributes.includes(264)) result.push(idFacility.bayLocated);
    if (idsAttributes.includes(217)) result.push(idFacility.adultsOnly);
    if (hasAirConditioner(idsAttributes)) result.push(idFacility.airConditioner);
    if (hasWifi(idsAttributes)) result.push(idFacility.wifi);
    if (idsAttributes.includes(166)) result.push(idFacility.withAnimals);
    if (idsAttributes.includes(147)) result.push(idFacility.spaAndHealth);
    if (idsAttributes.includes(185) || idsAttributes.includes(64)) result.push(idFacility.jacuzzi);
    if (idsAttributes.includes(69) || idsAttributes.includes(263)) result.push(idFacility.parking);
    if (idsAttributes.includes(148) || idsAttributes.includes(149)) result.push(idFacility.saunaBathHammam);
    if (hasForCouples(idsTypes, idsAttributes)) result.push(idFacility.forCouples);
    if (hasWithKids(idsTypes, idsAttributes)) result.push(idFacility.withKids);

    return result;
}

function hasAirConditioner(idsAttributes: number[]): boolean {
    return idsAttributes.includes(83) || idsAttributes.includes(212) || idsAttributes.includes(233);
}

function hasWifi(idsAttributes: number[]): boolean {
    return idsAttributes.includes(74)
        || idsAttributes.includes(88)
        || idsAttributes.includes(226)
        || idsAttributes.includes(227)
        || idsAttributes.includes(234)
        || idsAttributes.includes(237);
}

function hasForCouples(idsTypes: number[], idsAttributes: number[]): boolean {
    return idsTypes.includes(8)
        || idsAttributes.includes(169)
        || idsAttributes.includes(220)
        || idsAttributes.includes(217);
}

function hasWithKids(idsTypes: number[], idsAttributes: number[]): boolean {
    return idsTypes.includes(5)
        || idsAttributes.includes(109)
        || idsAttributes.includes(229)
        || idsAttributes.includes(112);
}
